export interface LegalSection {
  heading: string
  body: string
}

export interface LegalDocument {
  title: string
  intro: string
  sections: LegalSection[]
}

export const termsDocument: LegalDocument = {
  title: 'Términos y Condiciones',
  intro:
    'Al reservar y participar en La Herradura Dorada aceptas los siguientes términos. Te recomendamos leerlos con atención antes de confirmar tu espacio.',
  sections: [
    {
      heading: '1. Descripción del servicio',
      body: 'La Herradura Dorada es una experiencia privada de acompañamiento personal 1:1 de 45 minutos, impartida por Careliz Griman y realizada de forma online. Incluye una conversación personalizada, la exploración de tu situación actual, la identificación de posibles áreas de bloqueo, una hoja de ruta inicial y la Guía de Reconexión Energética.',
    },
    {
      heading: '2. Naturaleza del acompañamiento',
      body: 'La Herradura Dorada es un espacio de orientación, desarrollo personal y autoobservación. NO constituye terapia psicológica, tratamiento médico, asesoramiento financiero, legal ni sanitario, y no sustituye la atención de profesionales de la salud. Si atraviesas una situación clínica o de salud mental, te recomendamos acudir a un profesional acreditado.',
    },
    {
      heading: '3. Ausencia de garantía de resultados',
      body: 'Los resultados de cualquier proceso de desarrollo personal dependen de factores individuales, incluyendo tu compromiso, tu contexto y las acciones que decidas tomar. No se garantizan resultados económicos, emocionales, de abundancia, de sanación ni de ningún otro tipo. La sesión ofrece perspectiva, claridad y orientación, no promesas de resultados futuros.',
    },
    {
      heading: '4. Reserva y pago',
      body: 'El pago debe realizarse de forma anticipada para confirmar la reserva del espacio. Una vez confirmado el pago, recibirás las instrucciones para agendar tu sesión y el enlace de conexión.',
    },
    {
      heading: '5. Reprogramación y cancelación',
      body: 'Puedes reprogramar tu sesión por una única vez avisando con un mínimo de 48 horas de anticipación. Las ausencias sin aviso previo se consideran sesión realizada. Dado el carácter personalizado y reservado del espacio, no se realizan reembolsos una vez confirmada la reserva.',
    },
    {
      heading: '6. Puntualidad y duración',
      body: 'La sesión tiene una duración de 45 minutos contados desde la hora agendada. Las demoras en la conexión por parte de la participante no extienden la duración de la sesión.',
    },
    {
      heading: '7. Confidencialidad',
      body: 'Todo lo compartido durante la sesión es tratado de forma confidencial. Del mismo modo, los materiales, guías y contenidos entregados son para tu uso personal y no pueden ser compartidos, reproducidos, distribuidos ni comercializados.',
    },
    {
      heading: '8. Propiedad intelectual',
      body: 'Los contenidos de esta página, el test de autoobservación, la metodología de los tres códigos, la marca La Herradura Dorada y todos los materiales asociados son propiedad de Careliz Griman y están protegidos por derechos de autor.',
    },
    {
      heading: '9. Uso del test',
      body: 'El test disponible en esta página es una herramienta de autoobservación y reflexión personal. No constituye una evaluación psicológica, un diagnóstico clínico ni una valoración profesional de ningún tipo.',
    },
    {
      heading: '10. Modificaciones',
      body: 'Estos términos pueden ser actualizados en cualquier momento. La versión vigente será siempre la publicada en esta página.',
    },
  ],
}

export const privacyDocument: LegalDocument = {
  title: 'Política de Privacidad',
  intro:
    'Tu privacidad es importante. Aquí te explicamos qué información recogemos, para qué la usamos y cuáles son tus derechos.',
  sections: [
    {
      heading: '1. Datos que recogemos',
      body: 'Recogemos únicamente la información que tú proporcionas de forma voluntaria: nombre, correo electrónico, número de WhatsApp y las respuestas del test de autoobservación, incluida la respuesta abierta.',
    },
    {
      heading: '2. Finalidad del tratamiento',
      body: 'Utilizamos tus datos para enviarte el resultado de tu test, comprender mejor tu momento actual antes de la sesión, coordinar la reserva, hacerte llegar los materiales incluidos y mantener comunicación contigo sobre esta experiencia.',
    },
    {
      heading: '3. Comunicaciones',
      body: 'Podemos enviarte información relacionada con esta experiencia y otros acompañamientos. Puedes solicitar dejar de recibir estas comunicaciones en cualquier momento respondiendo a cualquier mensaje o escribiéndonos directamente.',
    },
    {
      heading: '4. Conservación y seguridad',
      body: 'Conservamos tus datos únicamente durante el tiempo necesario para las finalidades descritas y aplicamos medidas razonables para protegerlos. Tus datos no son vendidos, alquilados ni cedidos a terceros con fines comerciales.',
    },
    {
      heading: '5. Cookies y medición',
      body: 'Esta página utiliza tecnologías de medición, incluido el píxel de Meta, para analizar la interacción de las visitantes y mejorar la comunicación de esta experiencia. Puedes configurar tu navegador para limitar o rechazar cookies.',
    },
    {
      heading: '6. Proveedores',
      body: 'Para prestar el servicio utilizamos herramientas de terceros como plataformas de videollamada, correo electrónico, mensajería y publicidad. Cada proveedor trata los datos según sus propias políticas.',
    },
    {
      heading: '7. Tus derechos',
      body: 'Puedes solicitar en cualquier momento el acceso, la rectificación, la limitación o la eliminación de tus datos personales escribiéndonos por los canales oficiales de contacto.',
    },
    {
      heading: '8. Menores de edad',
      body: 'Esta experiencia está dirigida a personas mayores de 18 años. No recogemos de forma intencionada datos de menores de edad.',
    },
  ],
}
